// @flow

export const ADD_CONFIG_BUILDER: 'listo/configuration/configBuilder/ADD_CONFIG_BUILDER' = 'listo/configuration/configBuilder/ADD_CONFIG_BUILDER';

export default null;
